<template>
  <div class="card">
    <header class="header-card columns is-marginless">
      <div class="column pdt-0 pdl-0">
        <p>{{ $t('editionCommande.indexation.title')}}</p>
      </div>
      <b-field class="column is-narrow pdt-0">
        <qd-switch v-model="commande.estIndexable"/>
      </b-field>
    </header>
    <div class="card-content">
      <div v-if="!indiceEtValeursLoad" class="columns is-multiline">
        <div class="column is-6">
          <b-field
            :label="$t('editionCommande.indexation.nomIndice')"
            custom-class="has-text-default">
            <b-select
              v-model="indiceSelected"
              @input="actionIndiceChange"
              :disabled="!commande.estIndexable"
              expanded>
              <option :value="null">
                {{ $t('editionCommande.indexation.personnalise') }}
              </option>
              <option
                v-for="item in indiceEtValeurs"
                :key="item.id"
                :value="item">
                {{ item.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div v-if="commande.estIndexable" class="column is-6">
          <b-field
            :label="$t('editionCommande.indexation.valeurReference')"
            custom-class="has-text-default">
            <b-select
              v-model="valueurIndiceSelected"
              @input="actionValeurIndiceChange"
              :disabled="!commande.estIndexable"
              expanded>
              <option :value="null"> {{ $t('editionCommande.indexation.personnalise') }} </option>
              <option
                v-for="item in indicesValeursList"
                :key="item.id"
                :value="item">
                {{ func.formatIndice(item.valeurIndice, item.dateReference) }}
                {{ trimestre(item) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div v-if="commande.estIndexable" class="column is-4">
          <b-field :label="$t('indexation.edit.labelDateIndexation')">
            <b-datepicker
              v-model="commande.dateIndexationReference"
              @input="actionValeurChange"
              :disabled="!commande.estIndexable"
              :placeholder="$t('ajoutEditContrat.indexation.dateIndice')"
              icon="calendar-today"
              position="is-bottom-right"
              nearby-selectable-month-days
              show-week-number
              editable
            />
          </b-field>
        </div>
        <div v-if="commande.estIndexable" class="column is-4">
          <b-field :label="$t('indexation.edit.labelValueIndexation')">
            <input-currency
              v-model="commande.valeurIndexationReference"
              @input="actionValeurChange"
              :disabled="!commande.estIndexable"
              :placeholder="$t('ajoutEditContrat.indexation.valeurIndice')"
              isNumber="true">
            </input-currency>
          </b-field>
        </div>
        <div v-if="commande.estIndexable" class="column is-4">
          <b-field :label="$t('editionCommande.indexation.dateDerniereIndexation')">
            <b-datepicker
              v-model="commande.dateDerniereIndexation"
              icon="calendar-today"
              position="is-bottom-right"
              nearby-selectable-month-days
              show-week-number
              editable
              disabled
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAll } from '@/api/indiceEtValeur/';
import messageErreur from '@/services/general/messageErreur';
import inputCurrency from '@/components/general/inputCurrency';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { formatIndice } from '@/services/indexation/getItemIndicesValeurs';

export default {
  name: 'IndexationCommandeEdit',
  components: {
    inputCurrency,
  },
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      indiceEtValeurs: [],
      indiceEtValeursLoad: true,
      indiceSelected: null,
      valueurIndiceSelected: null,
      func: {
        formatIndice,
      },
    };
  },
  computed: {
    indicesValeursList() {
      return this.indiceSelected?.indiceValeurs || [];
    },
  },
  methods: {
    trimestre(indiceValeur) {
      const trimestre = indiceValeur?.trimestre;
      return trimestre ? ` (${trimestre})` : '';
    },
    async getIndiceEtValeur() {
      this.indiceEtValeursLoad = true;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const { items } = (await getAll({ limit: NO_PAGINATION })).data.result;
        this.indiceEtValeurs = items;
        const findIndice = this.indiceEtValeurs
          .find(el => el.id === this.commande.indiceReferenceId);
        if (findIndice) {
          findIndice.indiceValeurs.sort((a, b) => a.dateReference < b.dateReference);
          this.indiceSelected = findIndice;
          this.handlerIndiceSelected(findIndice);
        }
        this.indiceEtValeursLoad = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        this.indiceEtValeursLoad = false;
        loadingComponent.close();
        throw e;
      }
    },
    actionTypeIndexationChange() {
      this.commande.valeurIndexationReference = 0;
      this.commande.dateIndexationReference = null;
      this.commande.indiceReferenceId = '';
    },
    actionIndiceChange(val) {
      this.commande.indiceReferenceId = val?.id || null;
      this.handlerIndiceSelected(val);
    },
    handlerIndiceSelected(indice) {
      const valeur = this.commande.valeurIndexationReference;
      const date = this.commande.dateIndexationReference;
      if (!indice) return;
      const indiceFormat = this.func.formatIndice(valeur, date);
      const find = indice.indiceValeurs
        .find(el => this.func.formatIndice(el.valeurIndice, el.dateReference) === indiceFormat);
      if (find) this.valueurIndiceSelected = find;
      else this.valueurIndiceSelected = null;
    },
    actionValeurChange() {
      this.valueurIndiceSelected = null;
    },
    actionValeurIndiceChange(val) {
      this.commande.valeurIndexationReference = val?.valeurIndice || 0;
      this.commande.dateIndexationReference = val ? new Date(val.dateReference) : null;
    },
  },
  async mounted() {
    await this.getIndiceEtValeur();
  },
};
</script>
